export default {
  middleware_url: "https://wip.ltm-warning.fluid-it.fr",
  cake_url: "https://cake.wip.ltm-warning.fluid-it.fr",
  pwa_url: "https://app.wip.ltm-warning.fluid-it.fr/",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  instancePrefix: "29",
  googleMap: {
    api: "AIzaSyBC_3j0i4FLr0PU5C0dEJg0W8peGoLkVZM",
  },
};
